__turbopack_context__.v({
  "column": "EmptyFormatColumn-module__tAJWTG__column",
  "dots": "EmptyFormatColumn-module__tAJWTG__dots",
  "grid": "EmptyFormatColumn-module__tAJWTG__grid",
});
